// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__Co_G0","hide":"Video_hide__k3y7i"};